import { render, staticRenderFns } from "./LeftNavBar.vue?vue&type=template&id=bfe107f6&scoped=true&"
import script from "./LeftNavBar.vue?vue&type=script&lang=js&"
export * from "./LeftNavBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavBar.vue?vue&type=style&index=0&id=bfe107f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe107f6",
  null
  
)

export default component.exports